import React, { ReactElement } from "react";
import Title from "ui/Title/Title";
import Container from "ui/Container/Container";
import Button from "ui/Button/Button";
import Link from "ui/Link/Link";

import { useUrl } from "helpers/hooks";
import styles from "./Placeholder404.module.scss";

const Placeholder404: React.FC = (): ReactElement => {
  const { getLinkProps } = useUrl();
  return (
    <Container>
      <div className={styles.placeholder}>
        <Title className={styles.placeholderTitle} as="h1" size="h2">
          Ошибка 404
        </Title>
        <div className={styles.placeholderDescription}>
          Страница, которую вы запрашиваете, не существует. Возможно,
          она&nbsp;устарела, удалена, или был&nbsp;введен&nbsp;неверный адрес
          в&nbsp;адресной строке
        </div>

        <div className={styles.placeholderButton}>
          <Link {...getLinkProps("/")}>
            <Button orange fluid>
              Вернуться на главную
            </Button>
          </Link>
        </div>
      </div>
    </Container>
  );
};

export default Placeholder404;
